import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const normalised = String(value).replace(/[£,\s]/g, "");
  const amount = Number(normalised);

  if (!Number.isFinite(amount)) return String(value);

  return `£${amount.toLocaleString("en-GB", {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

const PrintSection3 = ({ section3 }) => {
  return (
    <>
      {" "}
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 3 – Activity
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Activity history - last ten years
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Please provide details of your complete employment, self-employment
        (full-time and/or part-time), unemployment, and/or education for the
        last ten years from the date of your application. References will be
        requested from all past and present employers covering the most recent
        six years. For any periods of unemployment or where benefits were
        claimed, verification will be required from the DWP Office or your
        personal referees.
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        If there are any employers you would prefer us not to contact at this
        stage, please explain fully below. Please note that we must request and
        receive references from all previous employers within the last six years
        before we can proceed with your appointment.
      </Text>
      {section3?.workHistory &&
      Object.keys(section3?.workHistory).length > 0 ? (
        Object.values(section3?.workHistory).map((history, index) => (
          <View key={index}>
            {/* Name of Firm */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                3.{index + 1} Work History
              </Text>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Name of Firm
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.nameOfFirm || ""}</Text>
              </View>
            </View>

            {/* Nature of Business */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Nature of Business
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.natureOfBusiness || ""}</Text>
              </View>
            </View>

            {/* Address Details */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Address of Firm
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.addressOfFirm || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Town</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.firmTown || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>County</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.firmCounty || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Postcode</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.firmPostcode || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Contact Details of the Firm (Telephone Number)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.officeTelephone || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Contact Details of the Firm (Email Address)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.emailAddress || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                {index === 0 ? "Current Income (£)" : "Income (£)"}
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{formatCurrency(history?.currentIncome)}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Dates of employment/Self-employment/Education
              </Text>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>From</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {formatPrintDate(history?.from)}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>To</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {formatPrintDate(history?.to)}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Is the firm regulated by the FCA?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {history.FCARegulated === true
                    ? "Yes"
                    : history.FCARegulated === false
                      ? "No"
                      : history.FCARegulated === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If regulated, what is your role?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {history.regulatedRole === true
                    ? "Yes"
                    : history.regulatedRole === false
                      ? "No"
                      : history.regulatedRole === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Are you or the firm an appointed representative?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {history.appointedRepresentative === true
                    ? "Yes"
                    : history.appointedRepresentative === false
                      ? "No"
                      : history.appointedRepresentative === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            {/* <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Is the firm regulated by the FCA?
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {history.regulatedByFCA
                      ? "Yes"
                      : history.regulatedByFCA === false
                      ? "No"
                      : history.regulatedByFCA === "N/A"
                      ? "Not Applicable"
                      : ""}
                  </Text>
                </View>
              </View> */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If yes, please confirm the life assurance company or network
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.lifeAssuranceCompany || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Date your authorisation commenced
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {formatPrintDate(history?.authorisationCommenced)}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                What is your current role/job title and responsibilities?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.currentRole || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Education Details
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{history?.educationDetails || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.tableRow}>
              <View style={PrintApplicationStyles.inputSection}>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    {index === 0
                      ? "Current Employment Status"
                      : "Employment Status"}
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{history?.currentEmploymentStatus || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Reasons for leaving
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{history?.reasonsForLeaving || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Notice Period (weeks)
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{history?.noticePeriod || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Please advise when you intend to resign
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {formatPrintDate(history?.intendedResignation)}
                    </Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Do you have the status of Competent Adviser?
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {history.competentAdviser === true
                        ? "Yes"
                        : history.competentAdviser === false
                          ? "No"
                          : history.competentAdviser === "N/A"
                            ? "Not Applicable"
                            : ""}
                    </Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Can we contact this firm for a reference?
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {history.contactForReference === true
                        ? "Yes"
                        : history.contactForReference === false
                          ? "No"
                          : history.contactForReference === "N/A"
                            ? "Not Applicable"
                            : ""}
                    </Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    If ‘No’, please tell us why
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{history?.reasonForNoReference || ""}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ))
      ) : (
        <Text>No work history available.</Text>
      )}
      <View style={PrintApplicationStyles.inputSection}>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>
            Please provide dates and names of all the Life Assurance Companies
            or Networks of which you have been an appointed representative in
            the last 5 years
          </Text>
        </View>
      </View>
      <View style={PrintApplicationStyles.table}>
        <View style={PrintApplicationStyles.tableRow}>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Date
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Company
          </Text>
        </View>
        {section3?.lifeAssuranceCompanies &&
        Object.keys(section3.lifeAssuranceCompanies).length > 0
          ? Object.values(section3.lifeAssuranceCompanies).map(
              (company, index) => (
                <View style={PrintApplicationStyles.tableRow} key={index}>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {formatPrintDate(company?.date)}
                  </Text>
                  <Text style={PrintApplicationStyles.tableCell}>
                    {company?.company || ""}
                  </Text>
                </View>
              ),
            )
          : null}
      </View>{" "}
    </>
  );
};

export default PrintSection3;
